import SegmentStore from '../../../../../../SegmentStore';
import { CoachSelectFormField, FieldValue } from '../../../../Types';

interface Waiting {
  kind: 'waiting';
}

interface Initializing {
  kind: 'initializing';
  segmentStore: SegmentStore;
  formField: CoachSelectFormField;
}

interface Ready {
  kind: 'ready';
  formField: CoachSelectFormField;
  value: FieldValue[];
}

interface AutoSaving {
  kind: 'auto-saving';
  formField: CoachSelectFormField;
  value: FieldValue[];
}

export type State = Waiting | Initializing | Ready | AutoSaving;

export const waiting = (): Waiting => ({
  kind: 'waiting',
});

export const initializing = (
  segmentStore: SegmentStore,
  formField: CoachSelectFormField,
): Initializing => ({
  kind: 'initializing',
  segmentStore,
  formField,
});

export const ready = (formField: CoachSelectFormField, value: FieldValue[]): Ready => ({
  kind: 'ready',
  formField,
  value,
});

export const autoSaving = (formField: CoachSelectFormField, value: FieldValue[]): AutoSaving => ({
  kind: 'auto-saving',
  formField,
  value,
});
